/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React, { createContext, useContext, useEffect, useState } from "react";
import { viewApp } from "../../auth/core/_requests";

interface Settings {
  dateFormat: string;
  timeFormat: string;
  timeZone: string;
}

interface SettingsContextType {
  settings: Settings;
  refreshSettings: () => void;
}

const SettingsContext = createContext<SettingsContextType | undefined>(undefined);

export const SettingsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [settings, setSettings] = useState<Settings>({
    dateFormat: "MMM dd, yyyy",
    timeFormat: "hh:mm a", // Default 12-hour format
    timeZone: "America/New_York",
  });

  const fetchSettings = async () => {
    try {
      const res = await viewApp(1); // Assuming '1' is the ID
      if (res?.data) {
        setSettings(res.data);
      }
    } catch (error) {
      console.error("Failed to fetch settings", error);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);



  return (
    <SettingsContext.Provider value={{ settings, refreshSettings: fetchSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error("useSettings must be used within a SettingsProvider");
  }
  return context;
};
